import React from 'react';

const Alerts = () => {
  return <h1>Alerts</h1>;
};

export default Alerts;
